import { createTheme } from '@mui/material';
import colors from '.././config/palette.scss';
import themePalette from './palette';

export const theme = (customization) => {
  const themeOption = {
    colors
  };

  const themeOptions = {
    palette: themePalette(themeOption),
    typography: {
      fontFamily: '"Poppins", "sans-serif"'
    }
  };

  const themes = createTheme(themeOptions);

  return themes;
};
